import * as _ from 'lodash'
import React from 'react';
import * as contractorActions from '../contractorActions';
import componentServices from '../componentServices';
import enums from '../enum';
import globalRelay from '../globalRelay';
import { AsyncButton } from './sharedComponents';
import { getModel, ModelCollection } from 'Scripts/store';

const _contractSections = [{ key: 'contract/header', name: 'Header', filterTest: ({ jobCost }) => !jobCost.currentChangeOrder && jobCost.companyVariant !== 'costco'},
	{ key: 'contract/renoagreement', name: 'Cabinet and Renovation Agreement', filterTest: ({ jobCost, hasSubtrades }) => !jobCost.currentChangeOrder && hasSubtrades && jobCost.companyVariant !== 'costco'},
	{ key: 'contract/sop', name: 'Scope of Work', filterTest: ({ jobCost, hasSubtrades }) => !jobCost.currentChangeOrder && hasSubtrades && jobCost.companyVariant !== 'costco'},
	{ key: 'contract/installagreement', name: 'Cabinet Supply & Installation Agreement', filterTest: ({ job, jobCost, hasSubtrades }) => !jobCost.isSupplyOnly && !jobCost.currentChangeOrder && !hasSubtrades && job.businessSegment !== enums.businessSegments.Builder && jobCost.companyVariant !== 'costco'},
	{ key: 'contract/installagreement', name: 'Cabinet Supply Agreement', filterTest: ({ job, jobCost, hasSubtrades }) => jobCost.isSupplyOnly && !jobCost.currentChangeOrder && !hasSubtrades && job.businessSegment !== enums.businessSegments.Builder && jobCost.companyVariant !== 'costco'},
	{ key: 'contract/installagreement', name: 'Cabinetry Design, Specifications and Installation Agreement', filterTest: ({ jobCost }) => !jobCost.currentChangeOrder && jobCost.companyVariant === 'costco'},
	{ key: 'contract/cabinetspecs', name: 'Cabinet and Wood and Finish Specifications', filterTest: ({ jobCost }) => !jobCost.currentChangeOrder },
	{ key: 'contract/appliancespecs', name: 'Appliance Specifications', filterTest: ({ jobCost }) => !jobCost.currentChangeOrder && _.filter(jobCost.specifications, spec => spec.group === enums.specGroups.Appliance).length > 0},
	{ key: 'contract/countertopspecs', name: 'Countertop Specifications', filterTest: ({ jobCost }) => !jobCost.currentChangeOrder && globalRelay.config!.companyKey === "legacy-kitchens" && jobCost.getLineItemsByType(['solid-surface-counter']).length > 0},
	{ key: 'contract/warranty', name: 'Warranty', filterTest: ({ jobCost }) => !jobCost.currentChangeOrder },
	{ key: 'contract/accessories', name: 'Cabinet Modifications & Accessories', filterTest: ({ jobCost }) => !jobCost.currentChangeOrder && _.filter(jobCost.getLineItemsByType(['outside-supplier', 'warehouse', 'misc']), li => (li.reportingFlags & enums.jobCostLineItemReportingFlags.Contract_Hidden) === 0 ).length > 0},
	{ key: 'contract/client-upgrade', name: 'Client Upgrades', filterTest: ({ job, jobCost }) => !jobCost.currentChangeOrder && !!job.builderKey && jobCost.getLineItemsByType(['client-upgrade']).length > 0 },
	{ key: 'contract/builder-summary', name: 'Builder Summary', filterTest: ({ job, jobCost }) => !jobCost.currentChangeOrder && !!job.builderKey && jobCost.getLineItemsByType(['builder-upgrade', 'client-upgrade']).length > 0 },
	{ key: 'contract/payment', name: 'Pricing & Payment Summary', filterTest: ({ jobCost }) => !jobCost.currentChangeOrder && jobCost.getLineItemsByType(['builder-upgrade', 'client-upgrade']).length === 0 && jobCost.companyVariant !== 'costco' },
	{ key: 'contract/privacy', name: 'Personal Information & Privacy', filterTest: ({ job, jobCost }) => !!jobCost.currentChangeOrder && (job.isRenovation || !job.builderKey) }];

const _presets = [{ key: 'contract/quote', name: 'Quotation', filterTest: ({ job, jobCost }) => !jobCost.currentChangeOrder && job.businessSegment !== enums.businessSegments.Builder && jobCost.companyVariant !== 'costco'},
	{ key: 'contract/quick', name: 'Quick Contract', filterTest: ({ job, jobCost, hasSubtrades }) => !jobCost.currentChangeOrder && !hasSubtrades && job.businessSegment !== enums.businessSegments.Builder && jobCost.companyVariant !== 'costco'},
	{ key: 'contract/clientsignoff', name: 'Client Signoff', filterTest: ({ job, jobCost }) => !jobCost.currentChangeOrder && !!job.builderKey && job.businessSegment !== enums.businessSegments.Builder && jobCost.companyVariant !== 'costco'},
	// { key: 'contract/summary', name: 'Questions & Summary', filterTest: ({ jobCost }) => !jobCost.currentChangeOrder },
	{ key: 'contract/customer', name: 'Customer Contract', filterTest: ({ jobCost }) => !!jobCost.currentChangeOrder && jobCost.companyVariant !== 'costco'}];

export default class JobCostEditContract extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.state = this.getStateFromProps();

		this.handleAllClientItemsChange = this.handleAllClientItemsChange.bind(this);
		this.printSelected = this.printSelected.bind(this);
	}

	UNSAFE_componentWillReceiveProps () {
		this.setState(this.getStateFromProps());
	}

	getStateFromProps () {
		const { jobCost } = this.props;
		const { store } = componentServices;
		const job = getModel({ store, collection: ModelCollection.jobs, key: jobCost.jobKey });
		const state = _.assign({}, this.state);

		if (job && job.builderKey) {
			if (!state.builder || state.builder.key !== job.builderKey) {
				state.builder = getModel({ store, collection: ModelCollection.contractors, key: job.builderKey});

				if (!state.builder && state.fetchedBuilderKey !== job.builderKey) {
					// this prevents endless fetch calls if the builder somehow went missing
					state.fetchedBuilderKey = job.builderKey;
					contractorActions.fetchContractor({ key: job.builderKey });
				}
			}
		}
		else {
			state.builder = undefined;
			state.fetchedBuilderKey = undefined;
		}

		if (!state.reports) {
			const filterParams = { job: job, jobCost: jobCost, hasSubtrades: !!jobCost.getLineItemsByType('subtrade').length, supplyOnly: jobCost.isSupplyOnly };
			state.reports = {};
			//console.log(jobCost)
			state.reports.sections = _.map(_.filter(_contractSections, section => !section.filterTest || section.filterTest(filterParams)), r => {
				return _.assign({ selected: false }, r);
			});

			state.reports.presets = _.map(_.filter(_presets, preset => !preset.filterTest || preset.filterTest(filterParams)), r => {
				return _.assign({ selected: false }, r);
			});

			globalRelay.filterState('contractReports', filterParams, state.reports);
		}

		return state;
	}

	handleSectionDocumentSelected (key, e) {
		const selected = e.target.checked;

		this.setState(previousState => {
			const nextState = _.assign({}, previousState);
			const report = _.find(nextState.reports.sections, { key: key });

			if (report) {
				report.selected = selected;
			}

			return nextState;
		});
	}

	handleAllClientItemsChange (e) {
		const selected = e.target.checked;

		this.setState(previousState => {
			const nextState = _.assign({}, previousState);

			_.forEach(nextState.reports.sections, report => {
				report.selected = selected;
			});

			return nextState;
		});
	}

	printSelected () {
		const { fetchReport } = this.props;
		const { reports } = this.state;
		const selectedKeys = _.map(_.filter(reports.sections, report => report.selected), report => {
			return report.key.split('/')[1];
		});

		return fetchReport(`contract/aggregate?sections=${selectedKeys.join(',')}`);
	}

	printReport (key) {
		const { fetchReport } = this.props;

		return fetchReport(key);
	}

	render () {
		const { reports } = this.state;
		let someSectionsSelected = false;
		let allSectionsSelected = true;

		const sectionRows = _.map(reports.sections, report => {
			if (report.selected) {
				someSectionsSelected = true;
			}
			else {
				allSectionsSelected = false;
			}

			const className = _.last(reports.sections) === report ? 'divider' : '';

			return (<tr key={report.key} className={ className } >
				<td />
				<td><label><input type="checkbox" checked={ report.selected } onChange={this.handleSectionDocumentSelected.bind(this, report.key)}/>{ report.name }</label></td>
				<td className="action"><button className="icon iconOnly print" onClick={ this.printReport.bind(this, report.key) }><span /></button></td>
				<td />
			</tr>);
		});

		const presetRows = _.map(reports.presets, report => {
			return (<tr key={report.key} className="preset" >
				<td />
				<td>{ report.name }</td>
				<td className="action"><button className="icon iconOnly print" onClick={ this.printReport.bind(this, report.key) }><span /></button></td>
				<td />
			</tr>);
		});

		return (
			<section>
				<header>
					<span>CONTRACT</span>
					<div className="actions">
						<AsyncButton className={ !someSectionsSelected ? 'disabled' : '' } asyncAction={ this.printSelected } label="Print Selected" />
					</div>
				</header>
				<div className="inner jobContractDocs">
					<table className="compact" cellPadding="0" cellSpacing="0">
						<thead>
							<tr>
								<td />
								<td><label><input type="checkbox" checked={ allSectionsSelected } onChange={this.handleAllClientItemsChange}/>Document</label></td>
								<td className="action">Print</td>
								<td />
							</tr>
						</thead>
						<tbody>
							{ sectionRows }
							{ presetRows }
						</tbody>
					</table>
				</div>
			</section>
		);
	}
}